<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { useGtm } from '@/hooks/useGtm'
import { useCustomization } from '@/hooks/useCustomization'
export default defineComponent({
  name: 'LenOptionChildRender',
  props: {
    item: {
      type: Object,
      default: () => ({} as AnyObject),
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selected'],
  setup(_, { emit }) {
    const { pushGtm } = useGtm()
    const customization = useCustomization()

    const refLenOption = ref()

    const isDemoMode = computed(() => customization.getCurrentDemoMode.value)

    const onSelect = (item) => {
      emit('selected', item)
      pushGtm(refLenOption.value)
    }

    return {
      refLenOption,
      onSelect,
      isDemoMode,
    }
  },
})
</script>

<template>
  <div class="col-6 col-sm-4">
    <div
      ref="refLenOption"
      v-ripple="!item.disabled" class="relative-position full-height bg-white column justify-center items-center cursor-pointer text-center q-py-sm rounded-borders"
      :class="[
        { 'non-selectable no-outline disabled': item.disabled },
        { border: isCurrent },
      ]"
      :glasson-click="item.gtmKey"
      @click="onSelect(item)"
    >
      <div
        v-if="isCurrent"
        class="absolute-top-right bg-transparent z-top"
        style="padding: 2px 4px"
      >
        <q-avatar
          class="shadow-3"
          color="secondary"
          text-color="white"
          size="sm"
        >
          <q-icon name="checked" size="16px" />
        </q-avatar>
      </div>
      <q-img
        :src="item.url"
        :style="`width: ${item.width}`"
        fit="contain"
        fetchpriority="high"
      />
      <div class="q-mt-xs text-wrap">
        <q-item-label
          class="text-caption" :class="[
            isCurrent ? 'text-weight-bold text-primary' : 'text-dark',
          ]"
        >
          {{ item.label }}
        </q-item-label>
        <template v-if="item.description">
          <q-separator
            class="q-my-xs q-mx-sm"
            :color="isCurrent ? 'secondary' : 'grey-5'"
          />
          <q-item-label :lines="1" class="text-small text-dark" caption>
            {{ item.description }}
          </q-item-label>
        </template>
        <!-- Hidden price -->
        <!-- <q-item-label
          v-if="!isDemoMode && item.additionFee > 0"
          :lines="1"
          class="q-pt-xs text-caption text-black text-weight-bold"
          caption
        >
          {{ $filters.currency(item.additionFee) }}(税込)
        </q-item-label> -->
      </div>
    </div>
  </div>
</template>
